import React from 'react'
import styled from 'styled-components'

const BenefitContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #253163;
  width: 288px;
  padding: 0;

  h1 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    margin: 8px 0 0;
  }

  h2 {
    font-size: 24px;
    line-height: 30px;
    font-weight: 700;
    margin: 0;
  }

  p {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    margin: 8px 0 0;
    padding: 0;
  }
`

export const Benefit = ({ icon, title, subtitle, text }) => (
  <BenefitContainer>
    <img src={icon} height={122} alt="" />
    <h1>{title}</h1>
    <h2>{subtitle}</h2>
    <p>{text}</p>
  </BenefitContainer>
)
